import React from 'react';
import PropTypes from 'prop-types';

import {connectAppEnv} from '../../app/app-env';
import {withUILevel} from '../../lib/react/oe-higher-order-components';
import {oeInterfaceManager} from '../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../react-oe/oe-interface-adapter';
import OELicensingAccessProvider from '../../react-oe/oe-licensing-access-provider';
import {UIControllerType} from '../../react-oe/oe-types';
import {OEManualViewLinks} from '../views/manual-view/oe-manual-view-model';
import OEPopover from '../views/oe-popover';
import OEIcon from '../elements/oe-icon';
import OEButton from '../elements/controls/oe-button';
import {OEGroupControl, OEControl, OEToggleCheckboxControl} from '../elements/controls/oe-controls';
import OEIconCodes from '../../lib/oe-icon-codes';
import {OECutControllerStyle} from '../../lib/oe-types';
import {OEDefaultConfigFactory} from '../oe-default-configs';
import OEToolbox from '../../lib/tools/oe-toolbox';
import LocalStorage from '../../lib/tools/local-storage';
import retardUpdate from '../../lib/react/update-retarder';

export class OECutControllerStd extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            uiEnabled: false,
            mode: 0,
            componentMode: 0,
            touchShift: false,
            strings: {
                title: '',
                modeOff: '',
                modeTouch: '',
                modeSwipe: '',
                options: '',
                componentModeAll: '',
                componentModeTapped: ''
            }
        };

        this.updateLanguage = this.updateLanguage.bind(this);
        this.updateControlsState = this.updateControlsState.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);

        this.onIsOpenStateChanged = this.onIsOpenStateChanged.bind(this);
        this.onPopoverRef = this.onPopoverRef.bind(this);
        this.renderAdditionalButtons = this.renderAdditionalButtons.bind(this);

        this.onHelpBtnPressed = this.onHelpBtnPressed.bind(this);
        this.onResetBtnPressed = this.onResetBtnPressed.bind(this);
        this.onModeTouchBtnPressed = this.onModeTouchBtnPressed.bind(this);
        this.onModeSwipeBtnPressed = this.onModeSwipeBtnPressed.bind(this);
        this.onComponentModeAllBtnPressed = this.onComponentModeAllBtnPressed.bind(this);
        this.onComponentModeTappedBtnPressed = this.onComponentModeTappedBtnPressed.bind(this);
        this.onTouchShiftSwitchChanged = this.onTouchShiftSwitchChanged.bind(this);
    }

    componentDidUpdate(prevProps)   {
        if(prevProps.config.showHelp !== this.props.config.showHelp) this.showHelpModalWhenOpen();
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.cutModeChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.cutComponentsModeChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.cutTouchShiftChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.cutModeChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.cutComponentsModeChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.cutTouchShiftChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    updateLanguage()   {
        let si = this.oe.sharedInterface;
        this.setState({strings: {
            title: si.getLocalizedStringEnc('cut_view'),
            modeOff: si.getLocalizedStringEnc('cut_view_off'),
            modeTouch: si.getLocalizedStringEnc('cut_view_touch'),
            modeSwipe: si.getLocalizedStringEnc('cut_view_swipe'),
            options: si.getLocalizedStringEnc('cut_view_options'),
            componentModeAll: si.getLocalizedStringEnc('cut_view_all'),
            componentModeTapped: si.getLocalizedStringEnc('cut_view_tapped'),
            touchShift: si.getLocalizedStringEnc('cut_touch_shift')
        }});
    }

    updateControlsState()   {
        let cut = this.oe.sharedInterface.getUIControllerCut();
        let mode = cut.getMode();
        let componentsMode = cut.getComponentsMode();

        let modeVal = mode.value;
        let componentsModeVal = componentsMode.value;
        
        componentsModeVal = componentsModeVal === 2 ? 1 : componentsModeVal;

        this.setState({
            mode: modeVal,
            componentMode: componentsModeVal,
            touchShift: cut.getTouchShift()
        });
    }

    updateUIState()   {
        let cut = this.oe.sharedInterface.getUIControllerCut();

        this.setState({ uiEnabled: cut.getUIEnabled() });

        if(cut.getUIVisible()) {
            if(cut.getMode() === this.oe.Module.CutMode.disabled)   {
                cut.setMode(this.oe.Module.CutMode.touch);
            }
        }
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.setState({uiEnabled: false});
            return;
        }
        
        retardUpdate(this, () => {
            this.updateLanguage();
            this.updateControlsState();
            this.updateUIState();
        });
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(userInfo.type === this.oe.Module.UIControllerType.cut) {
            this.updateUIState();
        }
    }

    onIsOpenStateChanged(sender, isOpen)  {
        if(isOpen) this.showHelpModalWhenOpen();
    }

    onPopoverRef(ref)   {
        if(this.popover === ref) return;
        this.popover = ref;
        if(this.popover) this.showHelpModalWhenOpen();
    }

    showHelpModalWhenOpen() {
        if(this.props.config.showHelp && this.popover && this.popover.isOpen() && LocalStorage.getItem('cutWidgetOpened') !== 'true')   {
            if(this.props.appComponent)    this.props.appComponent.uiLayer.manualView.setOpen(true, {link: OEManualViewLinks.cut});
            LocalStorage.setItem('cutWidgetOpened', 'true');
        }
    }

    renderAdditionalButtons(props)  {
        return (
            <OEButton disabled={!props.uiEnabled} className={props.buttonClassName + ' reset-btn'} onPressed={this.onResetBtnPressed}>
                <OEIcon code={OEIconCodes.reset} />
            </OEButton>
        );
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OEPopover 
                    className="popover-control"
                    placement="right-start"
                    buttonClassName="transparent-btn"
                    moduleId={this.props.moduleId}
                    uiControllerType={UIControllerType.cut}
                    boundariesElement={this.props.boundariesElement}
                    target={this.props.target}
                    onIsOpenStateChanged={this.onIsOpenStateChanged}
                    title={this.state.strings.title}
                    additionalButtons={this.renderAdditionalButtons}
                    uiEnabled={this.state.uiEnabled}
                    onHelpBtnPressed={this.props.config.showHelpBtn ? this.onHelpBtnPressed : null}
                    ref={this.onPopoverRef}
                >

                    <div className="cut-controller">

                        <OEGroupControl>
                            <OEControl>
                                <OEButton
                                    disabled={!this.state.uiEnabled}
                                    activated={this.state.mode === 1}
                                    className="iconTextBtn cc-button transparent-btn"
                                    onPressed={this.onModeTouchBtnPressed}
                                >
                                    <span><OEIcon code={OEIconCodes.cutToolTouch}/></span><span>{this.state.strings.modeTouch}</span>
                                </OEButton>

                                <OEButton
                                    disabled={!this.state.uiEnabled}
                                    activated={this.state.mode === 2}
                                    className="iconTextBtn cc-button transparent-btn"
                                    onPressed={this.onModeSwipeBtnPressed}
                                >
                                    <span><OEIcon code={OEIconCodes.cutToolSwipe}/></span><span>{this.state.strings.modeSwipe}</span>
                                </OEButton>
                            </OEControl>
                        </OEGroupControl>

                        <OEGroupControl 
                            title={this.state.strings.options}
                            type={OEGroupControl.type.fullCollapsable}
                            collapsed={this.state.mode !== 1}
                            topSeparator={true}
                        >
                            <OEControl>

                                <OEButton
                                    disabled={!(this.state.uiEnabled && this.state.mode === 1)}
                                    activated={this.state.componentMode === 0}
                                    className="iconTextBtn cc-button transparent-btn option left"
                                    onPressed={this.onComponentModeAllBtnPressed}
                                >
                                    <span><OEIcon code={OEIconCodes.cutToolAll}/></span><span>{this.state.strings.componentModeAll}</span>
                                </OEButton>

                                <OEButton
                                    disabled={!(this.state.uiEnabled && this.state.mode === 1)}
                                    activated={this.state.componentMode === 1}
                                    className="iconTextBtn cc-button transparent-btn option right"
                                    onPressed={this.onComponentModeTappedBtnPressed}
                                >
                                    <span><OEIcon code={OEIconCodes.cutToolTouched}/></span><span>{this.state.strings.componentModeTapped}</span>
                                </OEButton>

                            </OEControl>

                            {!this.props.config.touchShiftAvailable ? null :
                                <OEToggleCheckboxControl
                                    title={this.state.strings.touchShift}
                                    active={this.state.touchShift}
                                    disabled={!this.state.uiEnabled || this.state.mode !== 1}
                                    onClick={this.onTouchShiftSwitchChanged}
                                />
                            }

                        </OEGroupControl>

                    </div>

                </OEPopover>
            </React.Fragment>
        );
    }

    onHelpBtnPressed()  {
        if(this.props.appComponent)    this.props.appComponent.uiLayer.manualView.setOpen(true, {link: OEManualViewLinks.cut});
    }

    onResetBtnPressed() {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerCut().resetCut();
        this.oe.sharedInterface.postNotification(this.oe.NotificationName.uiInstanceCutResetBtnPressed, null);
    }

    onModeTouchBtnPressed() {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerCut().setMode(this.oe.Module.CutMode.touch);
    }

    onModeSwipeBtnPressed() {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerCut().setMode(this.oe.Module.CutMode.swipe);
    }

    onComponentModeAllBtnPressed()  {
        if(!this.oe.isReady() || this.state.mode !== 1) return;
        this.oe.sharedInterface.getUIControllerCut().setComponentsMode(this.oe.Module.CutComponentsMode.all);
    }

    onComponentModeTappedBtnPressed()  {
        if(!this.oe.isReady() || this.state.mode !== 1) return;
        this.oe.sharedInterface.getUIControllerCut().setComponentsMode(this.oe.Module.CutComponentsMode.tapped);
    }

    onTouchShiftSwitchChanged() {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerCut().setTouchShift(!this.state.touchShift);
    }
}

OECutControllerStd.defaultProps = {
    moduleId: '',
    target: ''
};

OECutControllerStd.propTypes = {
    moduleId: PropTypes.string
};

export class OECutControllerMinimal extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            uiEnabled: false,
            mode: 0,
            componentMode: 0,
            strings: {}
        };

        this.updateLanguage = this.updateLanguage.bind(this);
        this.updateControlsState = this.updateControlsState.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);

        this.onResetBtnPressed = this.onResetBtnPressed.bind(this);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.cutModeChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.cutComponentsModeChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.cutModeChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.cutComponentsModeChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    updateLanguage()   {
        let si = this.oe.sharedInterface;
        this.setState({strings: {}});
    }

    updateControlsState()   {
        let cut = this.oe.sharedInterface.getUIControllerCut();
        let mode = cut.getMode();
        let componentsMode = cut.getComponentsMode();

        let modeVal = mode.value;
        let componentsModeVal = componentsMode.value;
        
        componentsModeVal = componentsModeVal === 2 ? 1 : componentsModeVal;

        this.setState({
            mode: modeVal,
            componentMode: componentsModeVal
        });
    }

    updateUIState()   {
        let cut = this.oe.sharedInterface.getUIControllerCut();

        this.setState({uiEnabled: cut.getUIEnabled()});

        if(cut.getUIVisible()) {
            if(cut.getMode() === this.oe.Module.CutMode.disabled)   {
                cut.setMode(this.oe.Module.CutMode.touch);
            }
        }
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.setState({uiEnabled: false});
            return;
        }
        
        retardUpdate(this, () => {
            this.updateLanguage();
            this.updateControlsState();
            this.updateUIState();
        });
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(userInfo.type === this.oe.Module.UIControllerType.cut) {
            this.updateUIState();
        }
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OEPopover
                    className="popover-control"
                    placement="right-start"
                    hideArrow={true}
                    noHeader={true}
                    moduleId={this.props.moduleId}
                    uiControllerType={UIControllerType.cut}
                    boundariesElement={this.props.boundariesElement}
                    target={this.props.target}
                >

                    <div className="cut-controller-minimal">
                        <OEButton disabled={!this.state.uiEnabled} className="transparent-btn main-menu-button reset-btn" onPressed={this.onResetBtnPressed}>
                            <OEIcon code={OEIconCodes.reset} />
                        </OEButton>
                    </div>

                </OEPopover>
            </React.Fragment>
        );
    }

    onResetBtnPressed() {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerCut().resetCut();
        this.oe.sharedInterface.postNotification(this.oe.NotificationName.uiInstanceCutResetBtnPressed, null);
    }
}

OECutControllerMinimal.defaultProps = {
    moduleId: '',
    target: ''
};

OECutControllerMinimal.propTypes = {
    moduleId: PropTypes.string
};

export class OECutController extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.licensingAccess = OELicensingAccessProvider.defaultLicensingAccess();

        this.style = this.determineStyle();

        this.state = {
            style: this.style
        };

        this.onLicensingAccess = this.onLicensingAccess.bind(this);
    }

    componentWillReceiveProps(nextProps)   {
        if(!OEToolbox.shallowEqual(nextProps.config, this.props.config, true))  {
            this.updateStyle(nextProps);
        } else if(nextProps.config.enableTouchShift !== this.props.enableTouchShift) {
            this.setTouchShiftToDefault(nextProps);
        }
    }

    setTouchShiftToDefault(props)    {
        props = props || this.props;
        if(!this.oe.isReady())   return;
        let cut = this.oe.sharedInterface.getUIControllerCut();
        cut.setTouchShift(!!props.config.enableTouchShift);
    }

    determineStyle(props)   {
        props = props || this.props;
        let config = props.config;
        let style = config.style !== OECutControllerStyle.minimal ? OECutControllerStyle.std : OECutControllerStyle.minimal;

        if(config.featureAccess && this.licensingAccess && this.licensingAccess.isConnected && this.licensingAccess.isLicensing && this.licensingAccess.isValid)    {
            if(config.featureAccess[this.licensingAccess.edition] === OECutControllerStyle.minimal) style = OECutControllerStyle.minimal;
        }

        return style;
    }

    updateStyle(props)  {
        let style = this.determineStyle(props);
        if(style === this.style)    return;
        let prevStyle = this.style;
        this.style = style;
        this.setState({style: this.style});
        this.onStyleChanged(prevStyle, props);
    }

    onStyleChanged(prevStyle, props)   {
        this.adaptForStyle(props);
    }

    adaptForStyle(props) {
        if(!this.oe.isReady() || this.style !== OECutControllerStyle.minimal)   return;

        let cut = this.oe.sharedInterface.getUIControllerCut();

        if(cut.getMode() === this.oe.Module.CutMode.swipe)   {
            cut.setMode(cut.getUIVisible() ? this.oe.Module.CutMode.touch : this.oe.Module.CutMode.disabled);
        }

        cut.setComponentsMode(this.oe.Module.CutComponentsMode.all);

        this.setTouchShiftToDefault(props);
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }
        
        this.adaptForStyle();
        this.setTouchShiftToDefault();
    }

    onLicensingAccess(licensingAccess) {
        this.licensingAccess = licensingAccess;
        this.updateStyle();
    }

    render() {
        let config = this.props.config;
        if(!config.enabled) return null;

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OELicensingAccessProvider moduleId={this.props.moduleId} omitUpdateOnRelease={true} onLicensingAccess={this.onLicensingAccess}/>

                {this.state.style !== OECutControllerStyle.minimal ? <OECutControllerStd {...this.props}/> : <OECutControllerMinimal {...this.props}/>}
            </React.Fragment>
        );
    }
}

OECutController.defaultProps = {
    moduleId: '',
    target: '',
    config: OEDefaultConfigFactory.cutController()
};

OECutController.propTypes = {
    moduleId: PropTypes.string,
    config: PropTypes.shape({
        enabled: PropTypes.bool,
        showHelp: PropTypes.bool,
        showHelpBtn: PropTypes.bool,
        style: PropTypes.oneOf([OECutControllerStyle.std, OECutControllerStyle.minimal]),
        touchShiftAvailable: PropTypes.bool,
        enableTouchShift: PropTypes.bool,
        featureAccess: PropTypes.object
    }).isRequired
};

export default connectAppEnv((env) => {
    const ui = env.config.module.uiLayerConfig;
    return {
        appComponent: env.component,
        config: OEDefaultConfigFactory.combineShowHelpState(ui.widgetConfig.cutController, ui.widgetConfig.showHelp, ui.manualView.links, OEManualViewLinks.cut)
    }
})(withUILevel(OECutController));